<template>
  <div>
    <h3 class="title mb-3 green--text">Carências</h3>
    <table>
      <thead>
        <tr>
          <th class="text-xs-left">Carências</th>
          <th class="text-xs-left">Prazo</th>
          <th class="text-xs-left">A cumprir</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="width: 220px">Procedimentos Ambulatoriais</td>
          <td>
            {{
              beneficiarioPinss ? beneficiarioPinss.carenciaAmbulatorial : ""
            }}
          </td>
          <td>
            {{
              beneficiarioPinss
                ? beneficiarioPinss.carenciaAmbulatorialCumprir
                : ""
            }}
          </td>
        </tr>
        <tr>
          <td>Procedimentos Hospitalares</td>
          <td>
            {{ beneficiarioPinss ? beneficiarioPinss.carenciaHospitalar : "" }}
          </td>
          <td>
            {{
              beneficiarioPinss
                ? beneficiarioPinss.carenciaHospitalarCumprir
                : ""
            }}
          </td>
        </tr>
        <tr>
          <td>Procedimentos Parto a Termo</td>
          <td>
            {{ beneficiarioPinss ? beneficiarioPinss.carenciaPartoTermo : "" }}
          </td>
          <td>
            {{
              beneficiarioPinss
                ? beneficiarioPinss.carenciaPartoTermoCumprir
                : ""
            }}
          </td>
        </tr>
        <tr>
          <td>Procedimentos Odontológicos</td>
          <td>
            {{ beneficiarioPinss ? beneficiarioPinss.carenciaOdonto : "" }}
          </td>
          <td>
            {{
              beneficiarioPinss ? beneficiarioPinss.carenciaOdontoCumprir : ""
            }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "Beneficiario",
  props: {
    beneficiarioPinss: Object
  }
};
</script>

<style scoped lang="scss">
.pinss {
  p {
    margin-bottom: 8px;
  }
}
</style>
